export { Page as default } from '@ui/views/Index';
